const empty = {
	object: {},
	array: [],
}

export default empty
